import React, { createContext, useState } from "react";
import * as Icons from "@material-ui/icons";
import {
  IPAlign,
  IPBox,
  IPCenter,
  IPContainer,
  IPExitButton,
  Button,
} from "../assets/styles/ConfirmationPopUp";

export const confirmationPopUpContext = createContext({});

function ConfirmationPopUp({ children }) {
  const CloseIcon = Icons["Close"];
  const [confirmation, setConfirmation] = useState(false);

  return (
    <confirmationPopUpContext.Provider
      value={[confirmation, setConfirmation]}
    >
      {children}

      {confirmation.show === "open" && (
        <IPContainer>
          <IPCenter>
            <IPAlign>
              <IPExitButton onClick={() => setConfirmation({ show: "close", confirm: false })}>
                <CloseIcon
                  fontSize="small"
                  color="inherit"
                  style={{ margin: 3 }}
                />
              </IPExitButton>

              <IPBox>
                <h2>Deseja confirmar a transação?</h2>

                <Button style={{ background: "#6495ed", }}
                  onClick={() => setConfirmation({ show: "close", confirm: true, nit: confirmation.nit})}
                >
                  <strong>Confirmar</strong>
                </Button>
                <Button style={{ background: "#dc143c", }}
                  onClick={() => setConfirmation({ show: "close", confirm: false, nit: confirmation.nit})}
                >
                  <strong>Cancelar</strong>
                </Button>
              </IPBox>
            </IPAlign>
          </IPCenter>
        </IPContainer>
      )}
    </confirmationPopUpContext.Provider>
  );
}

export default ConfirmationPopUp;
